function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useLabelEditDialog_UpdateLabelMutation } from "sprout-graphql";
import { useCallback, useEffect, useRef } from "react";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import TextFieldPopoverDialog from "./TextFieldPopoverDialog";
const LabelEditTextPopoverDialog = (props)=>{
    const { label  } = props, rest = _objectWithoutProperties(props, [
        "label"
    ]);
    const { open , onOpenChange  } = rest;
    const inputRef = useRef(null);
    const [updateLabel] = useLabelEditDialog_UpdateLabelMutation();
    const showSnackbar = useSnackbar();
    const handleSubmit = useCallback((text)=>{
        updateLabel({
            variables: {
                labelId: label.id,
                text
            },
            optimisticResponse: {
                updateLabelById: {
                    label: _objectSpread({}, label, {
                        text
                    }),
                    __typename: "UpdateLabelPayload"
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        onOpenChange(false);
    }, [
        label,
        onOpenChange,
        showSnackbar,
        updateLabel
    ]);
    useEffect(()=>{
        if (open) {
            var ref;
            const { matches  } = window.matchMedia("only screen and (hover:hover) and (pointer:fine)");
            if (matches) (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.select();
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ _jsx(TextFieldPopoverDialog, _objectSpread({
        contextualTitle: "Rename label",
        placeholder: "Name this label",
        text: label.text,
        inputRef: inputRef,
        onSubmit: handleSubmit
    }, rest));
};
export default LabelEditTextPopoverDialog;
